module.exports = __webpack_public_path__ + "img/appAsset-brand--Zapier.cf652d3a.svg";